import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'primeicons/primeicons.css'
import './styles/main.css'
import App from './App.vue'
import { installPrimeVue } from './plugins/primevue'
import { router } from './router'
import { api } from './adapters/api'
import { useAuthStore } from './stores/auth'
import { useAccountStore } from './stores/account'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
installPrimeVue(app)
app.use(router)

const auth = useAuthStore(pinia)
const account = useAccountStore(pinia)
api.configure({
  getToken: async () => auth.session?.access_token ?? null,
  getAccountId: () => account.selectedId,
  refreshToken: () => auth.refreshToken(),
  onAcceptanceRequired: async () => {
    await auth.loadOnboarding()
    if (router.currentRoute.value.path !== '/onboarding') await router.push('/onboarding')
  },
})

app.mount('#app')
